/**
 * TN store names arrive either as a plain string or as a locale map
 * ({ es: '…', en: '…' }) depending on the store's language settings — see the
 * store rows in DynamoDB, where both shapes appear side by side.
 */
export function storeDisplayName(name: unknown): string | null {
  if (typeof name === 'string' && name.trim()) return name
  if (name && typeof name === 'object') {
    const map = name as Record<string, string>
    return map.es || map.en || Object.values(map)[0] || null
  }
  return null
}
